import { render, staticRenderFns } from "./EditMaintenance.vue?vue&type=template&id=1bb23a2a&scoped=true&"
import script from "./EditMaintenance.vue?vue&type=script&lang=js&"
export * from "./EditMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./EditMaintenance.vue?vue&type=style&index=0&id=1bb23a2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb23a2a",
  null
  
)

export default component.exports